import { AppConstants } from '@galigeo-store/shared-models'; // Import de AppConstants

export const REST_LOGIN = `${AppConstants.BASEPATH_NETWORK}/rest/login`;
export const REST_POI_API = `${AppConstants.BASEPATH_NETWORK}/rest/networks`;
export const REST_BUSINESSFIELDS = `${AppConstants.BASEPATH_NETWORK}/rest/businessFields`;
export const REST_GEOCODE = `${AppConstants.BASEPATH_NETWORK}/rest/geocode`;
export const REST_GEOCODE_REVERSE = `${REST_GEOCODE}/reverse`;
export const REST_GEOCODE_ADDRESS = `${REST_GEOCODE}/search`;
